import { alpha } from '@mui/material'
import type { ChartLineStyle } from '../components/colorSelector/lineStyle.types'
import type { EventsSettings } from '../components/chartV2/chart.typings'
import { CorporateAction, Type } from '../proto/generated/corporate-action'
import { CompanyEventProto, PurposeType } from '../proto/generated/company_event'

export const defaultEventsSettings = {
    showDividends: true,
    showSplits: true,
    showEarnings: true,
    showSessionBreaks: true,
    sessionBreakColor: '#2962FF',
    sessionBreakColorOpacity: 1,
    sessionBreakLineStyle: 'large_dashed' as ChartLineStyle,
    showLatestNews: true,
}

const DIVIDEND_TYPES = new Set([
    Type.INTERIM_DIVIDEND,
    Type.FINAL_DIVIDEND,
    Type.SPECIAL_DIVIDEND,
])

const EARNINGS_PURPOSES = new Set([
    PurposeType.BOARD_MEETING,
    PurposeType.FINANCIAL_RESULTS,
])

export const getEffectiveSessionBreakColor = (settings: EventsSettings | undefined) => {
    const color = settings?.sessionBreakColor ?? defaultEventsSettings.sessionBreakColor
    const opacity = settings?.sessionBreakColorOpacity ?? defaultEventsSettings.sessionBreakColorOpacity
    return alpha(color, opacity)
}

export const filterCorporateActionsByDate = (
    data: Record<number, CorporateAction[]>,
    settings: EventsSettings | undefined
): Record<number, CorporateAction[]> => {
    const showDividends = settings?.showDividends ?? defaultEventsSettings.showDividends
    const showSplits = settings?.showSplits ?? defaultEventsSettings.showSplits
    if (!showDividends && !showSplits) return {}

    const filtered: Record<number, CorporateAction[]> = {}
    Object.entries(data).forEach(([key, actions]) => {
        const kept = actions.filter((action) => {
            if (DIVIDEND_TYPES.has(action.type)) return showDividends
            if (action.type === Type.SPLIT) return showSplits
            return false
        })
        if (kept.length) filtered[Number(key)] = kept
    })
    return filtered
}

export const filterCompanyEventsByDate = (
    data: Record<number, CompanyEventProto[]>,
    settings: EventsSettings | undefined
): Record<number, CompanyEventProto[]> => {
    const showEarnings = settings?.showEarnings ?? defaultEventsSettings.showEarnings
    if (!showEarnings) return {}

    const filtered: Record<number, CompanyEventProto[]> = {}
    Object.entries(data).forEach(([key, events]) => {
        const kept = events.filter((event) =>
            event.purpose.some((purpose) => EARNINGS_PURPOSES.has(purpose))
        )
        if (kept.length) filtered[Number(key)] = kept
    })
    return filtered
}
